import {useState} from "react";
import "../styles/addTournament.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken,generateURN } from "./hmac";


const AddNotification = () => {
  const [form, setForm] = useState({
    heading:"",
    message:"",
    createdBy: "ADMIN",
  });

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");




  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
     [name]: value,
    }));
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    // Basic validation
    if (!form.heading || !form.message) {
      setMsg("Please fill both fields.");
      return;
    }

    try {
      setLoading(true);
      const {host,addAlert,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn,"admin");
      const res = await fetch(
        `https://${host}${addAlert.path}`,
         {
        method: addAlert.method,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization:`Basic ${basic.BASIC_AUTH_ADMIN}`,
          urn:urn,
          authToken:authToken,
          
        },
        body: JSON.stringify(form),
      });

      if (!res.ok ) {
        setMsg("Failed to add alert.");
        return;
      }

      setMsg("alert added successfully!");
     
      // Reset form
      setForm({
        heading:"",
        message:"",
        createdBy: "ADMIN",
      });
    } catch (err) {
      setMsg("Something went wrong: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-tournament-container">
      <h2 className="add-tournament-title">Add Notification</h2>

      <form className="add-tournament-form" onSubmit={handleSubmit}>
       

        {/* alert heading  */}
        <div className="field">
          <label>Alert Heading</label>
          <input
            type="text"
            name="heading"
            value={form.heading}
            onChange={handleChange}
            placeholder="New Tournament is Live!"
          />
        </div>
        {/* alert message */}
        <div className="field">
          <label>Alert Message</label>
          <input
            type="text"
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="The February Rapid Arena has started. Join now and compete to win gold…"
          />
        </div>


 <div className="spacing"></div>

        {/* Submit */}
        <button className="btn-primary" disabled={loading} type="submit">
          {loading ? "Adding..." : "Add Notification"}
        </button>

        {msg && <p className="form-msg">{msg}</p>}
      </form>
      <div className="spacing"></div>
    </div>
  );
};

export default AddNotification;
